import { motion } from "framer-motion";
import { FaPhoneAlt } from "react-icons/fa";

export const NeedCustomGlovebox = (props:any)=> {
  return (
    <section className="w-full relative overflow-hidden py-16 px-6 bg-gradient-to-r from-[#d40a0a] via-[#5A0A0A] to-[#651313]">
      {/* SHARP VECTOR — top left long angled shape */}
      <div
        className="absolute -top-10 -left-20 w-[380px] h-[220px] bg-[#ffffff1a] 
                      skew-x-12 rotate-3 opacity-20"
      ></div>

      {/* SHARP VECTOR — bottom right diagonal shape */}
      <div
        className="absolute -bottom-10 right-0 w-[420px] h-[230px] bg-[#ffffff10] 
                      -skew-x-12 -rotate-2 opacity-20"
      ></div>

      {/* SHARP VECTOR — thin slicing line */}
      <div className="absolute inset-0">
        <div className="absolute left-1/3 top-0 h-full w-[2px] bg-white/10 rotate-1"></div>
      </div>

      {/* DOT GRID */}
      <div
        className="absolute inset-0 opacity-10"
        style={{
          backgroundImage:
            "radial-gradient(circle, rgba(255,255,255,0.15) 1px, transparent 1px)",
          backgroundSize: "22px 22px",
        }}
      ></div>

      {/* CONTENT WRAPPER */}
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        className="relative z-10 max-w-7xl mx-auto w-full flex items-center justify-between flex-wrap gap-10"
      >
        {/* LEFT ICON — no border, no shadow */}
        {/* <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.5 }}
          className="p-2"
        >
          <img
            src={props.imgUrl}
            alt="icon"
            className="w-16 h-16 object-contain"
          />
        </motion.div> */}

        {/* CENTER TITLE + DESCRIPTION */}
        <div className="text-center flex-1 px-6">
          <h2 className="text-white text-5xl font-extrabold tracking-wide">
            {props.title}
          </h2>

          <p className="text-white/80 text-lg mt-3 max-w-2xl mx-auto leading-relaxed">
            {props.description}
          </p>
        </div>

        {/* RIGHT PHONE CTA — clean, modern */}
        <motion.div
          whileHover={{ scale: 1.05 }}
          className=""
        >
          <a href="tel:+9198446 06132" className="flex items-center gap-4 bg-white/10 backdrop-blur-md px-8 py-5 rounded-full 
                    border border-white/10 cursor-pointer hover:bg-white/20 transition">

          <FaPhoneAlt className="text-white text-xl" />

          <span className="text-white text-2xl font-semibold">
            {props.ctaText}
          </span>
          </a>
        </motion.div>
      </motion.div>
    </section>
  );
}
